import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import {
  selectJob,
  getSelections
} from 'app/actions/kioskActions';

import {
  selectMoments,
  unselectMoment
} from 'app/actions/kioskActions';

import {
  selectMoments as selectCartMoments
} from 'shared/actions/cartActions';

import {
  setPhotoSwipeMoment
} from 'app/actions/photoSwipeActions';

import {
  getStore
} from 'shared/services/Store';

import {
  trackEvent
} from 'shared/services/Analytics';

import Loading from 'shared/components/Loading';
import CatalogToolbar from 'app/components/CatalogToolbar';
import ImageGalleryContainer from 'app/components/ImageGalleryContainer';
import config from 'shared/config/config';
import Viewport from 'app/components/Viewport';

const styles = () => ({
  container: {
    position: 'relative',
    display: 'block',
    width: '100%',
    float: 'left'
  },
  navWrapper: {
    position: 'fixed',
    zIndex: 2,
    top: '7.7rem',
    left: 0,
    bottom: 0,
    width: '27vw',
    padding: 0,
    fontFamily: config.root_font_family
  },
  nav: {
    float: 'left',
    width: '100%',
    height: '100%',
    background: '#fff',
    padding: '0.5rem 1rem',
    borderRadius: '3px',
    boxShadow: '1px 1px 3px rgba(0, 0, 0, 0.1)',
    overflowY: 'auto'
  },
  navHeader: {
    fontSize: '1.3rem',
    fontWeight: 700,
    textAlign: 'center',
    padding: '0.4rem 0'
  },
  navItem: {
    float: 'left',
    width: '100%',
    margin: '0.3rem 0',
    padding: '0.5rem 0.9rem',
    cursor: 'pointer',
    background: 'linear-gradient(#ffffff, #f1f1f1)',
    borderRadius: '3px',
    border: '1px solid #dcdcdc',
    boxShadow: '0 0 2px #dcdcdc'
  },
  navItemThumbWrapper: {
    float: 'left',
    width: '4rem',
    marginRight: '1rem'
  },
  navItemThumb: {
    float: 'left',
    height: '2.5rem',
    width: 'auto',
  },
  navItemText: {
    float: 'left',
    width: 'calc(100% - 5rem)',
    marginTop: '0.4rem',
    fontSize: '1.1rem',
    fontWeight: 600,
    textAlign: 'left',
    color: '#2b8eb0',
    overflow: 'hidden'
  },
  jobList: {
    width: '100%',
    maxHeight: 'calc(100% - 6rem)',
    listStyleType: 'none',
    padding: '0.5rem',
    margin: 0,
    overflowX: 'visible',
    overflowY: 'auto'
  },
  job: {
    border: 'none',
    borderRadius: '3px',
    background: '#f1f1f1',
    fontSize: '1.2rem',
    fontWeight: 600,
    width: '100%',
    textAlign: 'center',
    padding: '0.6rem 0',
    marginBottom: '1.2rem',
    boxShadow: '1px 1px 3px 2px rgba(0, 0, 0, 0.3)',
    textTransform: 'uppercase',
    cursor: 'pointer'
  },
  moments: {
    float: 'right',
    width: '72vw',
    minHeight: '100vh',
    background: '#707072',
    paddingTop: '7.75rem',
    fontFamily: config.root_font_family
  },
});

class Catalog extends React.Component {
  constructor(props) {
    super(props);

    this.pageLoaded = {};
    this.store = getStore();
    this.loadedJobId = null;

    this.state = {
      loading: true,
      moments: [],
      galleryKey: Math.random()
    }
  }

  componentDidMount() {
    const { user } = this.props;

    if (user) {
      this.loadJobs();
    }
  }

  componentDidUpdate() {
    if (this.props.selectedJobId !== this.loadedJobId) {
      this.loadedJobId = this.props.selectedJobId;
      this.setMoments();
      this.setState({ galleryKey: Math.random() });
    }
  }

  //shouldComponentUpdate(newProps, newState) {
  //  return newProps.selectedJobId !== this.props.selectedJobId ||
  //    newState.loading !== this.state.loading ||
  //    newState.moments !== this.state.moments;
  //}

  loadJobs() {
    const {
      settings,
      user,
      getSelections
      //purchasedMomentIds
    } = this.props;

    return getSelections(settings.token, user.story_id)
      .then(() => {
        const { jobs } = this.store;

        if (jobs.allIds.length) {
          // select 1st job, alphabetically
          let sorted = jobs.allIds.sort((a, b) => {
            if (jobs.byId[a].name < jobs.byId[b].name) {
              return -1;
            } else {
              return 1;
            }
          });
          return this.loadJob(sorted[0]);
        } else {
          return Promise.resolve();
        }
      });
  }

  loadJob(jobId) {
    this.setState({
      loading: false
    });

    window.scrollTo(0, 0);

    return this.props.selectJob(jobId);
  }

  setMoments() {
    const {
      selectedJobId,
      purchasedMomentIds
    } = this.props;

    const {
      moments,
      jobMoments
    } = this.store;

    let ms = [];
    if (jobMoments[selectedJobId]) {
      ms = jobMoments[selectedJobId].filter(id => purchasedMomentIds.indexOf(id) === -1)
        .map(id => moments.byId[id])
        .sort((a, b) => a.id < b.id ? 1 : -1);
    }

    this.setState({ moments: ms });
  }

  onSelect(momentId, purchased) {
    const {
      settings,
      user,
      selectMoments,
      selectCartMoments,
      setPhotoSwipeMoment
    } = this.props;

    setPhotoSwipeMoment({ id: momentId, purchased });

    selectMoments(settings.token, user.story_id, [momentId])
      .then(() => {
        // if there is no gallery screen, then auto select image in the cart
        if (!settings.gallery_screen) {
          selectCartMoments(user.story_id, [momentId]);
        }
      });

    trackEvent('Kiosk.SelectImage', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId
    });
  }

  onUnselect(momentId) {
    const {
      settings,
      user,
      unselectMoment,
    } = this.props;

    unselectMoment(settings.token, user.story_id, momentId);

    trackEvent('Kiosk.UnselectImage', {
      userId: user.id,
      storyId: user.story_id,
      kiosk: settings.token,
      momentId
    });
  }

  render() {
    if (this.state.loading) {
      return (<Loading />);
    }

    const {
      classes,
      settings,
      selectedJobId
    } = this.props;

    const { jobs } = this.store;

    let js = jobs.allIds.map(id => jobs.byId[id])
      .sort((a, b) => a.name < b.name ? -1 : 1);

    let selectedJob = null;
    for (let j of js) {
      if (j.id === selectedJobId) {
        selectedJob = j;
        break;
      }
    }

    let jobName = selectedJob && selectedJob.name;
    let showSelectAll = selectedJob && selectedJob.id === -1;

    // for some reason this screen needs a checkbox margin of 0.4rem,
    // while the gallery and cart screens need 0.5rem
    let checkboxStyle = {
      margin: '0.3rem'
    }

    let gallery = null;
    if (this.state.moments.length) {
      gallery = (
        <Viewport>
          <ImageGalleryContainer
            header={jobName}
            showSelectAll={showSelectAll}
            moments={this.state.moments}
            selectedMomentIds={this.props.selectedMomentIds}
            selectEnabled={true}
            onSelect={this.onSelect.bind(this)}
            onUnselect={this.onUnselect.bind(this)}
            checkboxStyle={checkboxStyle}
            resolution={1}
            width="72vw"
            showDates={settings.show_dates}
            showCountByDate={settings.show_dates}
            selectKioskItem={true}
            galleryWorker={this.props.galleryWorker}
            galleryKey={this.state.galleryKey}
          />
        </Viewport>
      );
    }

    return (
      <div>
        <CatalogToolbar jobName={jobName} />
        <div className={classes.navWrapper}>
          <div className={classes.nav}>
            {js.map(job => {
              let style = {}, textStyle = {};
              if (job.id === this.props.selectedJobId) {
                style.borderColor = '#2b8eb0';
                style.boxShadow = '0 0 2px #2b8eb0';
                style.cursor = 'default';
                textStyle.color = '#000';
              }

              return (
                <div className={classes.navItem} style={style} onClick={() => this.loadJob(job.id)}>
                  <span className={classes.navItemThumbWrapper}>
                    <img className={classes.navItemThumb} src={job.cover_moment_thumb} />
                  </span>
                  <span className={classes.navItemText} style={textStyle}>
                    {job.name}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
        <div className={classes.moments}>
          <div className={classes.container}>
            {gallery}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  settings: state.kioskReducer.settings,
  selectedJobId: state.kioskReducer.selectedJobId,
  selectedMomentIds: state.kioskReducer.selectedMomentIds,
  purchasedMomentIds: state.cartReducer.purchasedMomentIds,
});

export default connect(mapStateToProps, { selectJob, getSelections, selectMoments, unselectMoment, setPhotoSwipeMoment, selectCartMoments })(withStyles(styles)(Catalog));
